<template>
    <v-dialog v-model="dialog" width="600px" class="pa-0 ma-0">
        <v-card>
            <v-card-title class="justify-center">{{ title }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-4">
                <v-row>
                    <v-col cols="12">
                        The rating will be set to "no rated set"<br>
                        <br>
                        {{ actions }}
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <btn_component data="" type="text" color="warning" text="Resubmit" tooltip="Actions will be executed" size="small" @actionClick="resubmitAction"/>
                <v-spacer></v-spacer>
                <btn_component data="" type="text" color="primary" text="cancel" tooltip="Back to the question" size="small" @actionClick="cancelAction"/>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    export default {
        components: {
            btn_component,
        },
        props: {
        },
        data() {
            return {
                dialog: false,
                title: "",
                actions: "",
                question: {},
            }
        },
        methods: { 
            openDialog(question) {
                this.question = question;
                this.new_rating = this.question.oavr_rating;
                this.title = "Resubmit the answer to chatGPT";
                this.actions = "The question will be reset and resubmitted to chatGPT.";
                this.dialog = true;
            },
            resubmitAction() {
                this.$axios.post("ares/json/ares/task/customer_success/openai/questionResubmit.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "questionResubmit"
                    },
                    questionResubmit: {
                        oavr_encrid: this.question.oavr_encrid,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.questionResubmit.text,
                            color: res.data.questionResubmit.color
                        });
                        this.$emit("updateAction", "resubmit");
                        this.closeDialog();
                    }
                });
            },
            cancelAction() {
                this.closeDialog();
            },
            closeDialog() {
                this.dialog = false;
            },
        }
    }
</script>